import type { CollectedValues, PrefetchedContact, StepDescriptor } from "./types";

/** POST /api/actions/resolver/next — success body. */
export interface ResolverNextApiResponse {
  step: StepDescriptor;
  collected: CollectedValues;
  prefetchedTargets?: PrefetchedContact[];
}

export function isResolverNextApiResponse(
  value: unknown,
): value is ResolverNextApiResponse {
  if (!value || typeof value !== "object") {
    return false;
  }
  const record = value as Record<string, unknown>;
  return (
    typeof record.step === "object" &&
    record.step !== null &&
    typeof record.collected === "object" &&
    record.collected !== null
  );
}
